import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=1c85692d&scoped=true&"
import script from "./lunbo.vue?vue&type=script&lang=js&"
export * from "./lunbo.vue?vue&type=script&lang=js&"
import style0 from "./lunbo.vue?vue&type=style&index=0&id=1c85692d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c85692d",
  null
  
)

export default component.exports